@if (runLink(); as link) {
  <a
    [class]="cardClass()"
    data-testid="live-pipe"
    [routerLink]="link.commands"
    [attr.aria-label]="
      'liveDashboard.livePipeline.openRunAria'
        | translate: { workflow: pipeline().workflow, project: pipeline().projectName }
    "
  >
    <ng-container [ngTemplateOutlet]="cardBody" />
  </a>
} @else {
  <span [class]="cardClass()" data-testid="live-pipe">
    <ng-container [ngTemplateOutlet]="cardBody" />
  </span>
}

<ng-template #cardBody>
  <span
    class="live-pipe-card__provider"
    data-testid="live-pipe-provider"
    [attr.aria-label]="'liveDashboard.livePipeline.provider.GITHUB' | translate"
  >
    <i class="fa-brands fa-github" aria-hidden="true"></i>
  </span>

  <span
    class="live-pipe-card__body"
    [attr.role]="running() ? 'status' : null"
    [attr.aria-live]="running() ? 'polite' : null"
  >
    <span class="live-pipe-card__head">
      <code class="live-pipe-card__workflow" data-testid="live-pipe-workflow">{{ pipeline().workflow }}</code>
      <span class="live-pipe-card__badge" data-testid="live-pipe-badge" [attr.data-status]="badge().status">
        @if (running()) {
          <span class="live-pipe-card__badge-dot" aria-hidden="true"></span>
        }
        {{ badge().label | translate }}
      </span>
      <span class="live-pipe-card__project" data-testid="live-pipe-project">{{ pipeline().projectName }}</span>
    </span>

    @if (current(); as work) {
      <span class="live-pipe-card__current" data-testid="live-pipe-current">
        <span class="live-pipe-card__spinner to-run-spinner" aria-hidden="true"></span>
        <span class="live-pipe-card__current-count">
          {{ currentLabelKey() | translate: { index: work.index, total: work.total } }}
        </span>
        <span class="live-pipe-card__current-name">{{ work.name }}</span>
      </span>
    } @else {
      <span class="live-pipe-card__source" data-testid="live-pipe-source">
        {{ pipeline().repository }} ·
        <code>{{ pipeline().branch }}</code>
      </span>
    }
  </span>

  <app-pipe-track
    class="live-pipe-card__track"
    data-testid="live-pipe-track"
    [cells]="cells()"
    [label]="trackLabel()"
  />

  <span class="live-pipe-card__meta">
    @if (hasFailure()) {
      <span class="live-pipe-card__failed" data-testid="live-pipe-failed">
        <mat-icon aria-hidden="true">close</mat-icon>
        {{ 'liveDashboard.livePipeline.failedCount' | translate: { count: counts().failed } }}
      </span>
    }
    <span class="live-pipe-card__count" data-testid="live-pipe-count">{{ counts().done }}/{{ counts().total }}</span>
    <span class="live-pipe-card__elapsed" data-testid="live-pipe-elapsed">
      @if (elapsed(); as clock) {
        {{ clock }}
      } @else if (duration(); as total) {
        {{ total }}
      } @else {
        {{ 'liveDashboard.livePipeline.finished' | translate }}
      }
    </span>
    <mat-icon class="live-pipe-card__chevron" aria-hidden="true">chevron_right</mat-icon>
  </span>
</ng-template>
